import { render, staticRenderFns } from "./AjustesConsol.vue?vue&type=template&id=1984069c"
import script from "./AjustesConsol.vue?vue&type=script&lang=js"
export * from "./AjustesConsol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports